var map = {
	"./icruise/config/modules/ecommerce.js": 65558,
	"./icruise/config/modules/icruise.js": 31305,
	"./icruise/config/modules/locale.js": 36130,
	"./icruise/config/modules/router.js": 33937,
	"./icruise/config/modules/style.js": 34509,
	"./icruise/config/modules/user.js": 42133,
	"./saffron/config/modules/locale.js": 58168,
	"./saffron/config/modules/router.js": 34044,
	"./saffron/config/modules/style.js": 91381,
	"./saffron/config/modules/user.js": 9789,
	"./saffronfiles/config/modules/locale.js": 94145,
	"./saffronfiles/config/modules/router.js": 25591,
	"./saffronfiles/config/modules/style.js": 39244,
	"./saffronfiles/config/modules/user.js": 88050
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10839;